export const getUserEmail = (user = {}) => {
  const emailLike =
    user?.email ||
    user?.EMAIL ||
    user?.username ||
    user?.USERNAME ||
    user?.userName ||
    user?.USER_NAME ||
    (typeof window !== 'undefined' ? window.localStorage?.getItem('userEmail') : '') ||
    '';

  return String(emailLike).trim();
};

export const getNormalizedUserEmail = (user = {}) => getUserEmail(user).toLowerCase();